
export interface IFillLangSkillsOpt { 
	/**
	 * Number of languages to show in the chart and cards.
	 */
	numLang?: number,
	/**
	 * Array with the names of languages to hide.
	 */
	toHide?: string[]
}

export enum SortBy {
	StartDate = "StartDate",
	EndDate = "EndDate",
}

export enum SortOrder {
	Ascending = "Ascending",
	Descending = "Descending",
}

export enum Context {
	Academic = "Academic",
	Professional = "Professional",
	Personal = "Personal",
}

export interface IFillProjSkillsOpt {
	/**
	 * Options to sort projects.
	 */
	sortBy?: SortBy,
	sortOrder?: SortOrder,
	/**
	 * Whether it is an academic, professional and/or personal project.
	 * An empty array means to show all contexts.
	 * 
	 * Possible values: "professional", "personal", "academic"
	 */
	context?: Context[],
	/**
	 * An array with my personal project ratings to show.
	 * An empty array means to show projects with all ratings.
	 * 
	 * Classifications range from "A" to "F".
	 */
	rating?: string[],
	/**
	 * An array with programming language names and/or related technologies.
	 * An empty array means to show projects of all languages and technologies.
	 */
	technologies?: string[]
}

export interface IFillProjSkillsSortOpt {
	sortBy: SortBy,
	sortOrder: SortOrder,
}
